import script from "./LockOpen.vue?vue&type=script&setup=true&lang=js"
export * from "./LockOpen.vue?vue&type=script&setup=true&lang=js"

import "./LockOpen.vue?vue&type=style&index=0&id=bd7c8b2a&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd7c8b2a"]])

export default __exports__